import { render, staticRenderFns } from "./UnfilledShifts.vue?vue&type=template&id=1a34eeb6&"
import script from "./UnfilledShifts.vue?vue&type=script&lang=js&"
export * from "./UnfilledShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports